import { WooCommercePopularProductsItem } from '../../core/interfaces/woo-commerce/api/products/popular-product-api.interface';
import { WooCommerceProduct } from '../../core/interfaces/woo-commerce/api/products/product-api.interface';
import { BaseWooCommerceProductImage } from '../../core/interfaces/woo-commerce/api/products/base-product-api.interface';
import { object2Array } from './convert-types.utils';

export function convertPopularProductToProduct(
  popularProduct: WooCommercePopularProductsItem
): WooCommerceProduct {
  const priceInCents = (parseFloat(popularProduct.price) * 100).toFixed(0);
  const regularPriceInCents = (
    parseFloat(popularProduct.regular_price) * 100
  ).toFixed(0);
  const salePriceInCents = popularProduct.sale_price
    ? (parseFloat(popularProduct.sale_price) * 100).toFixed(0)
    : priceInCents;

  // Extract clover images from meta_data
  const cloverImagesMeta = popularProduct.meta_data.find(
    (meta) => meta.key === '_clover_pos_images'
  );
  const cloverPosImages: string[] = cloverImagesMeta
    ? (cloverImagesMeta.value as unknown as string[])
    : [];

  // Map images
  const images = (popularProduct.images ||
    []) as unknown as BaseWooCommerceProductImage[];

  // Construct the product
  const productAddons = (
    Array.isArray(popularProduct.product_addons)
      ? popularProduct.product_addons
      : object2Array(popularProduct.product_addons) || popularProduct.addons
  )?.map((addon: any) => ({
    ...addon,
    key: addon.key || addon.id.toString(),
    options: addon.options.map(
      (addonOption: any, addonOptionIndex: number) => ({
        ...addonOption,
        value: addonOption.value || addonOptionIndex
      })
    )
  }));

  return {
    ...popularProduct,
    images: images,
    prices: {
      price: priceInCents,
      regular_price: regularPriceInCents,
      sale_price: salePriceInCents,
      price_range: null,
      currency_code: 'USD',
      currency_symbol: '$',
      currency_minor_unit: 2,
      currency_decimal_separator: '.',
      currency_thousand_separator: ',',
      currency_prefix: '$',
      currency_suffix: ''
    },
    clover_pos_images: cloverPosImages,
    product_addons: productAddons,

    // Map mismatched fields
    parent: popularProduct.parent_id || 0,
    variation: '',
    review_count: popularProduct.rating_count || 0,

    // boolean flags
    is_purchasable: popularProduct.purchasable,
    is_in_stock: popularProduct.stock_status === 'instock',
    is_on_backorder: popularProduct.backordered,
    low_stock_remaining: popularProduct.low_stock_amount,

    // add_to_cart object
    add_to_cart: {
      text: popularProduct.button_text || 'Add to cart',
      description: popularProduct.description || '',
      url: popularProduct.external_url || '',
      minimum: 1,
      maximum: popularProduct.manage_stock
        ? popularProduct.stock_quantity || 99
        : 99,
      multiple_of: 1
    },

    extensions: {},

    has_variants: false,
    has_available_variants: false,
    variants: []
  };
}

export function convertPopularProductsList(
  popularProducts: WooCommercePopularProductsItem[]
): WooCommerceProduct[] {
  return popularProducts.map(convertPopularProductToProduct);
}
